// Gegenstück zu marketing/src/lib/config.ts: dort zeigt die Marketing-Site auf die
// App, hier die App auf die Marketing-Site. Zur Build-Zeit über
// REACT_APP_MARKETING_URL gesetzt (docker-compose.yml), mit Fallback auf die
// Produktivdomain, damit lokale Builds keinen toten Link rendern.
export const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || 'https://audicio.de';

export const PRIVACY_URL = `${MARKETING_URL}/rechtliches/datenschutz`;
